import { render, staticRenderFns } from "./listApplyRoomDiscountRecordList.vue?vue&type=template&id=7024b5f9&scoped=true"
import script from "./listApplyRoomDiscountRecordList.vue?vue&type=script&lang=js"
export * from "./listApplyRoomDiscountRecordList.vue?vue&type=script&lang=js"
import style0 from "./listApplyRoomDiscountRecordList.vue?vue&type=style&index=0&id=7024b5f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024b5f9",
  null
  
)

export default component.exports